<div class="app-container">
  <app-mobile-topbar></app-mobile-topbar>
  <main class="app-content">
    <router-outlet></router-outlet>
  </main>
</div>